var React = require('react');

function White (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"10","stroke":"#fff","strokeWidth":"1","key":0}),React.createElement("ellipse",{"cx":"15.801","cy":"6.197","fill":"#fff","rx":"1.6","ry":"1.599","key":1}),React.createElement("path",{"fill":"#fff","d":"M4.601 4.598h3.2v12.791h-3.2zm4.8 4.796h3.2v7.994h-3.2zm4.8 4.797h3.2v3.198h-3.2z","key":2})]);
}

White.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = White;

White.default = White;
